/* eslint-disable no-underscore-dangle */
import parseRoute from '../utils/parseRoute.ts';
import ProductList, { type ProductListProps } from './ProductList.tsx';
import * as Remote from './Remote.ts';
import ProductListLayout from './ProductListLayout/ProductListLayout.tsx';
import {
  productTypePathToProductType,
  type ProductTechnology
} from '@/domain/Product.ts';
import Loader from '../components/containers/Loader/Loader.tsx';
import type { UseRoute } from '../hooks/useRoute.tsx';

async function load() {
  const route: UseRoute = window?.__pb__?.user
    ? buildPBRoute(window?.__pb__)
    : parseRoute(globalThis?.location?.href);
  const remoteData = await Remote.getRemoteData(route);

  return {
    route,
    ...remoteData
  };
}

type ProductListLoaderProps = {
  showSkeleton?: boolean;
};

export default function ProductListLoader({
  showSkeleton = true
}: ProductListLoaderProps) {
  return (
    <Loader<ProductListProps>
      load={load}
      showSkeleton={showSkeleton}
      renderSkeleton={() => <ProductListLayout.Skeleton />}
    >
      {({
        route,
        products,
        categories,
        config,
        marketConfig,
        productTranslations,
        customerProductRules
      }) => (
        <ProductList
          route={route}
          products={products}
          categories={categories}
          config={config}
          marketConfig={marketConfig}
          productTranslations={productTranslations}
          customerProductRules={customerProductRules}
        />
      )}
    </Loader>
  );
}

function buildPBRoute(pb: Window['__pb__']): UseRoute {
  const { user } = pb!;
  if (!user) return {} as UseRoute;
  return {
    market: user.market,
    channel: user.channel,
    technology: user.technology as ProductTechnology,
    locale: user.language,
    productTypePath: user.productList,
    productType: productTypePathToProductType(user.productList),
    inFavorites: false,
    inPLP: false,
    inPDP: false,
    slug: ''
  };
}
